import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import ImmutableProptypes from 'react-immutable-proptypes'
import { OrderedMap, Map, List } from 'immutable'
import update from 'immutability-helper'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { connect as reduxConnect } from 'react-redux'
import Modal from 'react-modal'
import Moment from 'moment'

import {
  createCaptureItem,
  getCaptureItems,
  editCaptureItem,
  updateCaptureItemStatus,
  updateCaptureItemDate,
  setCaptureItemsOrder,
  deleteCaptureItem,
  completeCaptureItem,
} from '_modules/capture-items/actions'
import { getTomorrowItems, createTomorrowItem } from '_modules/tomorrow-items/actions'
import { updateLastActivityAt } from '_modules/user/actions'
import { getTodayItems, createTodayItem } from '_modules/today-items/actions'
import { objectToArray, deepCopyJSON } from '_utils/helperFunction'
import { sortByOrder, sortByKeptAt } from '_utils/sort'

import styles from './styles.css'
import OrderingCard from './ordering-card'

const mapStateToProps = ({ captureItems, todayItems, tomorrowItems, user }) => ({
  captureItems,
  user,
  todayItems,
  tomorrowItems,
})

const mapDispatchToProps = {
  getCaptureItems,
  createCaptureItem,
  editCaptureItem,
  updateCaptureItemStatus,
  updateCaptureItemDate,
  setCaptureItemsOrder,
  deleteCaptureItem,
  completeCaptureItem,
  createTodayItem,
  getTodayItems,
  updateLastActivityAt,
  getTomorrowItems,
  createTomorrowItem,
}

@DragDropContext(HTML5Backend)
class CaptureItems extends PureComponent {
  static propTypes = {
    log: ImmutableProptypes.map,
    captureItems: ImmutableProptypes.orderedMap,
    todayItems: ImmutableProptypes.orderedMap,
    tomorrowItems: ImmutableProptypes.orderedMap,
    getTodayItems: PropTypes.func.isRequired,
    getCaptureItems: PropTypes.func.isRequired,
    setCaptureItemsOrder: PropTypes.func.isRequired,
    deleteCaptureItem: PropTypes.func.isRequired,
    createCaptureItem: PropTypes.func.isRequired,
    editCaptureItem: PropTypes.func.isRequired,
    updateCaptureItemStatus: PropTypes.func.isRequired,
    completeCaptureItem: PropTypes.func.isRequired,
    updateCaptureItemDate: PropTypes.func.isRequired,
    createTodayItem: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    getTomorrowItems: PropTypes.func.isRequired,
    createTomorrowItem: PropTypes.func.isRequired,
  }

  static defaultProps = {
    captureItems: new OrderedMap(),
    todayItems: new OrderedMap(),
    counter: new Map(),
    currentTask: new Map(),
    user: new Map(),
    tomorrowItems: new OrderedMap(),
  }

  state = {
    cards: [],
    todayCards: [],
    isModalOpen: false,
    modalName: '',
    modalId: undefined,
    showMore: false,
  }

  componentWillMount() {
    Modal.setAppElement('body')
    this.props.getCaptureItems()
    this.props.getTomorrowItems()
    this.props.getTodayItems()
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user.get('lastActivityAt') !== nextProps.user.get('lastActivityAt')) {
      this.props.getTodayItems()
      this.props.getCaptureItems()
    }
    this.getState(nextProps)
  }

  componentWillUnmount() {
    this.props.clearError()
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onConfirmModal(event)
    }
  }

  onAddClick = e => {
    e.preventDefault()

    this.setState(
      {
        isModalOpen: true,
        modalName: '',
        modalId: undefined,
      },
      () => {
        this.nameInput.focus()
      }
    )
  }

  onMoreClick = () => {
    this.setState({ showMore: !this.state.showMore })
  }

  onRefreshClick = () => {
    this.props.getCaptureItems()
    this.props.getTodayItems()
  }

  onModalChange = e => {
    e.preventDefault()

    const { id, value } = e.target

    this.setState({
      [id]: value,
    })
  }

  onCancelModal = e => {
    e.preventDefault()
    this.props.clearError()

    this.resetModal()
  }

  onConfirmModal = e => {
    e.preventDefault()
    this.props.clearError()

    const { modalName, modalId } = this.state

    if (!modalName) {
      this.props.displayError('Enter a capture item name')
      return
    }

    if (modalId) {
      this.modifyCaptureItem()
    } else {
      this.createCaptureItem()
    }

    this.setState({
      isModalOpen: false,
    })
  }

  getState = props => {
    const captureItems = objectToArray(props.captureItems.toJS()).sort(sortByOrder)
    const todayItems = objectToArray(props.todayItems.toJS()).sort(sortByOrder)

    this.setState({
      cards: captureItems,
      todayCards: todayItems,
    })
  }

  playCard = id => {
    const { cards, todayCards } = this.state

    const order = todayCards.reduce((prevVal, card) => {
      if (card.order > prevVal) {
        return card.order
      }
      return prevVal
    }, 0)

    const name = cards.filter(c => c._id === id)[0].name

    const payload = {
      name,
      order: order + 1,
    }

    this.props.createTodayItem(payload)
    this.props.deleteCaptureItem({ itemId: id })
  }

  editCard = id => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]

    this.setState(
      {
        isModalOpen: true,
        modalName: card.name,
        modalId: card._id,
      },
      () => {
        this.nameInput.focus()
      }
    )
  }

  checkCard = id => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]
    const time = new Date()

    if (card.status === 1) {
      const payload = { time, itemId: id, status: 1, type: 4, name: card.name }
      this.props.completeCaptureItem(payload)
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })
    } else {
      const payload = {
        time,
        itemId: id,
        status: 2,
        type: 4,
        name: card.name,
        logEntry: card.logEntry,
      }
      this.props.completeCaptureItem(payload)
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })
    }
  }

  shiftCard = id => {
    this.props.updateCaptureItemDate({ itemId: id })
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  deleteCard = id => {
    this.props.deleteCaptureItem({ itemId: id })
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  moveCard = (dragIndex, hoverIndex) => {
    const { cards } = this.state
    const dragCard = cards[dragIndex]

    this.setState(
      update(this.state, {
        cards: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]],
        },
      })
    )
  }

  saveOrdering = () => {
    const { cards } = this.state

    const payload = cards.reduce((obj, item, index) => {
      const newObj = { ...obj }
      newObj[item._id] = index
      return newObj
    }, {})

    this.props.setCaptureItemsOrder(payload)
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  resetModal = () => {
    this.setState({
      isModalOpen: false,
      modalName: '',
      modalId: '',
    })
  }

  modifyCaptureItem = () => {
    const { modalName: name, modalId: itemId, cards } = this.state
    const order = cards.filter(c => c._id === itemId)[0].order

    const payload = { itemId, name, order }
    this.props.editCaptureItem(payload)
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  createCaptureItem = () => {
    const { modalName: name, cards } = this.state

    const order = cards.reduce((prevVal, card) => {
      if (card.order > prevVal) {
        return card.order
      }
      return prevVal
    }, 0)

    const payload = {
      name,
      order: order + 1,
    }
    this.props.createCaptureItem(payload)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  createTomorrowItemCard = (id, sectionId) => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]

    const { tomorrowItems } = this.props
    // find last order in tomorrowItems
    const order = tomorrowItems.reduce((prevVal, c) => {
      if (c.order > prevVal) {
        return c.order
      }
      return prevVal
    }, 0)

    const payload = {
      name: card.name,
      order: order + 1,
      section: sectionId,
    }

    this.props.createTomorrowItem(payload)
    this.props.getTomorrowItems()
    this.props.deleteCaptureItem({ itemId: id })
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  filterToday = element => new Date(element.keptAt).toDateString() === new Date().toDateString()

  filterMore = cards => {
    const notToday = cards.filter(c => !this.filterToday(c))
    const notTodayIncomp = notToday.filter(task => task.status !== 2).sort(sortByKeptAt)
    return notTodayIncomp.reduce((groups, item) => {
      const day = Moment(item.keptAt).format('YYYY-MM-DD')
      if (groups.get(day)) {
        return groups.set(day, groups.get(day).push(item))
      }
      return groups.set(day, List.of(item))
    }, new OrderedMap())
  }

  renderStatus = status => {
    let iconName = ''

    switch (status) {
      case 1:
        iconName = 'fa-square-o'
        break
      case 2:
        iconName = 'fa-check-square-o'
        break
      default:
        iconName = 'fa-square-o'
    }

    return (
      <div
        role="button"
        tabIndex={0}
        className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.ellipsis)}
        onClick={this.onStatusClick}
      >
        <i className={`fa ${iconName}`} />
      </div>
    )
  }

  renderCards = group =>
    group.map(card => {
      const { cards } = this.state
      const arrIndex = cards.findIndex(x => x._id === card._id)
      return (
        <li key={card._id} className={classnames(styles['Grid-cell'], styles.pause)}>
          <OrderingCard
            index={arrIndex}
            moveCard={this.moveCard}
            id={card._id}
            saveOrdering={this.saveOrdering}
            deleteCard={this.deleteCard}
            editCard={this.editCard}
            playCard={this.playCard}
            checkCard={this.checkCard}
            shiftCard={this.shiftCard}
            createTomorrowItemCard={this.createTomorrowItemCard}
            name={card.name}
            status={card.status}
            date={card.keptAt}
          />
        </li>
      )
    })

  renderMore = (groups, date) => {
    if (!this.state.showMore) {
      return null
    }
    return (
      <div key={date} className={classnames(styles.Grid, styles['Grid--alignCenter'])}>
        <div className={classnames(styles['Grid-cell'], styles.date)}>
          {Moment(date).calendar(null, {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'MMM Do',
            lastDay: '[Yesterday]',
            lastWeek: 'MMM Do',
            sameElse: 'MMM Do',
          })}
        </div>
        <ul className={classnames(styles.list)}>{this.renderCards(groups)}</ul>
      </div>
    )
  }

  renderList = cards => {
    const today = cards.filter(this.filterToday)
    const more = this.filterMore(cards).reverse()
    const incomplete = today.filter(task => task.status !== 2)
    const complete = today.filter(task => task.status === 2)

    return (
      <div className={classnames(styles['Grid-cell'], styles['list-container'])}>
        <div className={classnames(styles.list, styles['Grid--alignCenter'])}>
          <ul>{this.renderCards(incomplete)}</ul>
          {!this.state.showMore && complete.length > 0 ? (
            <div>
              <div className={classnames(styles.date, styles['Grid--alignCenter'])}>Completed</div>
              <ul>{this.renderCards(complete)}</ul>
            </div>
          ) : (
            more
              .valueSeq()
              .map((groups, index) => this.renderMore(groups, more.keySeq().toArray()[index]))
          )}
        </div>
      </div>
    )
  }

  divRef = null

  render() {
    const { cards, isModalOpen, modalName } = this.state
    return (
      <div
        ref={div => (this.divRef = div)}
        className={classnames(styles.Grid, styles['Grid--alignCenter'], styles.main)}
      >
        <div className={classnames(styles['Grid-cell'], styles.title)}>Capture Page</div>
        {this.renderList(cards)}
        <div className={classnames(styles['Grid-cell'], styles['u-sizeFit'])}>
          <button className={classnames(styles['add-button'])} onClick={this.onAddClick}>
            Add New
          </button>
          <button className={classnames(styles['add-button'])} onClick={this.onMoreClick}>
            {this.state.showMore ? 'Show Less' : 'Show More'}
          </button>
          <button className={classnames(styles['add-button'])} onClick={this.onRefreshClick}>
            Refresh
          </button>
        </div>
        <Modal
          isOpen={isModalOpen}
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          onRequestClose={this.resetModal}
          shouldCloseOnOverlayClick
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
        >
          <div className={classnames(styles.Grid, styles['Grid--alignCenter'])}>
            <input
              ref={input => {
                this.nameInput = input
              }}
              type="text"
              id="modalName"
              placeholder="Name"
              value={modalName}
              onChange={this.onModalChange}
              onKeyPress={this.onKeyPress}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
            />
            <button
              onClick={this.onConfirmModal}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
            >
              SAVE
            </button>
            <button
              onClick={this.onCancelModal}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
            >
              CANCEL
            </button>
          </div>
        </Modal>
      </div>
    )
  }
}

export default reduxConnect(mapStateToProps, mapDispatchToProps)(CaptureItems)



// WEBPACK FOOTER //
// ./src/views/capture/index.js